import React, { useEffect, useState } from "react";
import InputField from "../../../components/common/inputfield/InputField";
import Selector from "../../../components/common/selects/Selector";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { getjobList, getUsersAll, updateJobs } from "../../../redux/Action";
import { Formik } from "formik";
import CustomSelector from "../../../components/common/customselector/CustomSelector";
import moment from "moment";
import Selector2 from "../../../components/common/selects/NewSelector.jsx";

const EditJob = ({ status }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const { allUserList, allJobList } = useSelector((state) => state?.main);
  const storeList = allUserList?.data?.stores || [];
  const ShiftList = allUserList?.data?.shift || [];
  const [updateForm, setUpdateForm] = useState({});

  const pathname = location.pathname;
  const pathParts = pathname.split("/");
  const userId = pathParts[pathParts.length - 1];
  const storeUsers = storeList.map((user) => ({
    label: user.name,
    value: user._id,
  }));

  const shifbytList = ShiftList.map((user) => ({
    label: user.name,
    value: user._id,
    start: user?.start_time,
    end: user?.end_time,
  }));

  const jobTimingList = [
    { id: 1, value: "9-5", label: "9:00 AM - 5:00 PM" },
    { id: 2, value: "10-6", label: "10:00 AM - 6:00 PM" },
    { id: 3, value: "11-7", label: "11:00 AM - 7:00 PM" },
    { id: 4, value: "12-8", label: "12:00 PM - 8:00 PM" },
    { id: 5, value: "night", label: "Night Shift (8:00 PM - 4:00 AM)" },
    { id: 6, value: "flexible", label: "Flexible Timing" },
  ];

  useEffect(() => {
    dispatch(getUsersAll());
  }, []);

  console.log(updateForm, "updateForm");

  useEffect(() => {
    dispatch(getjobList());
  }, []);

  useEffect(() => {
    // Dispatch the action to get the job list

    if (userId && allJobList) {
      const matchedJob = allJobList?.data?.jobs?.find(
        (job) => job._id === userId
      );

      if (matchedJob) {
        setUpdateForm(matchedJob);
      } else {
        setUpdateForm({});
      }
    } else {
      setUpdateForm({});
    }
  }, [userId, allJobList]);

  console.log(jobTimingList, "lll");

  // useEffect(() => {
  //   // Map API data to populate jobTimingList dynamically
  //   if (allJobList?.data?.jobs) {
  //     const timings = allJobList.data.jobs.map((item, index) => {
  //       const startTime = item?.shiftId?.start_time;
  //       const endTime = item?.shiftId?.end_time;

  //       if (startTime && endTime) {
  //         return {
  //           id: index + 1, // Generate a unique ID
  //           value: `${startTime}-${endTime}`, // Concatenate start and end times
  //           label: `${startTime} - ${endTime}`, // Create the label
  //         };
  //       }
  //       return null; // Exclude entries with missing data
  //     });

  //     // Filter out any null values and update the state
  //     setJobTimingList(timings.filter((timing) => timing !== null));
  //   }
  // }, [allJobList]);

  const optionsedu = [
    { value: "high_school", label: "High School" },
    { value: "diploma", label: "Diploma" },
    { value: "bachelor", label: "Bachelor's Degree" },
    { value: "master", label: "Master's Degree" },
    { value: "phd", label: "Doctorate (PhD)" },
    { value: "other", label: "Other" },
  ];
  const optionlanguage = [
    { value: "en", label: "English" },
    { value: "hi", label: "Hindi" },
    { value: "es", label: "Spanish" },
    { value: "fr", label: "French" },
    { value: "de", label: "German" },
    { value: "zh", label: "Chinese" },
    { value: "ja", label: "Japanese" },
    { value: "ru", label: "Russian" },
    { value: "ar", label: "Arabic" },
    { value: "pt", label: "Portuguese" },
  ];
  const optionsjobexperience = [
    { value: "0-1", label: "0-1 Years (Fresher)" },
    { value: "1-3", label: "1-3 Years" },
    { value: "3-5", label: "3-5 Years" },
    { value: "5-10", label: "5-10 Years" },
    { value: "10-15", label: "10-15 Years" },
    { value: "15+", label: "15+ Years" },
  ];
  console.log(
    allJobList?.data?.jobs?.map((item, index) => item?.shiftId?.start_time),
    "allJobList"
  );
  // const jobTimingList = [
  //   { id: 1, value: "9-5", label: "9:00 AM - 5:00 PM" },
  //   { id: 2, value: "10-6", label: "10:00 AM - 6:00 PM" },
  //   { id: 3, value: "11-7", label: "11:00 AM - 7:00 PM" },
  //   { id: 4, value: "12-8", label: "12:00 PM - 8:00 PM" },
  //   { id: 5, value: "night", label: "Night Shift (8:00 PM - 4:00 AM)" },
  //   { id: 6, value: "flexible", label: "Flexible Timing" },
  // ];
  console.log(updateForm, "updateForm");
  return (
    <div>
      <div className="container mx-auto mt-4 mb-4 ">
        <Formik
          initialValues={{
            jobemail: updateForm?.email,
            jobtitle: updateForm?.title,
            jobbio: updateForm?.bio,
            jobskill: updateForm?.skillSet,
            jobrequirement: updateForm?.requirement,
            jobstore: updateForm?.storeName,
            jobsalary: updateForm?.salary,
            jobrole: updateForm?.role,
            jobtime: updateForm?.jobtime,
            jobshift: updateForm?.shiftName,
            jobedulevel: updateForm?.educationLevel,
            language: updateForm?.language,
            jobexperience: updateForm?.experience,
            jobmobile: updateForm?.mobile,
            type: updateForm?.type,
          }}
          validate={(values, files, name) => {
            const errors = {};
            if (!values.jobtitle) {
              errors.jobtitle = "Job title is required";
            }
            if (!values.jobbio) {
              errors.jobbio = "Job bio is required";
            }
            if (!values.jobskill) {
              errors.jobskill = "Job skill set is required";
            }
            if (!values.jobrequirement) {
              errors.jobrequirement = "Job requirement is required";
            }
            if (!values.jobstore) {
              errors.jobstore = "Store selection is required";
            }
            if (!values.jobsalary) {
              errors.jobsalary = "Salary is required";
            }
            if (!values.jobrole) {
              errors.jobrole = "Job role is required";
            }
            // if (!values.jobtime) {
            //   errors.jobtime = "Job time is required";
            // }
            if (!values.jobshift) {
              errors.jobshift = "Job shift is required";
            }
            if (!values.jobedulevel) {
              errors.jobedulevel = "Education level is required";
            }
            if (!values.language) {
              errors.language = "Language is required";
            }
            if (!values.jobexperience) {
              errors.jobexperience = "Experience is required";
            }
            if (!values.jobmobile) {
              errors.jobmobile = "Mobile Number is required";
            } else if (!/^\d+$/.test(values.jobmobile)) {
              errors.jobmobile = "Mobile number must contain only digits";
            } else if (values.jobmobile.length < 10) {
              errors.jobmobile = "Mobile number must be exactly 10 digits long";
            }
            if (!values.jobemail) {
              errors.jobemail = "Email is required";
            } else if (
              !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.jobemail)
            ) {
              errors.jobemail = "Invalid email address";
            }

            return errors;
          }}
          onSubmit={(values, { setSubmitting }) => {
            const userData = new FormData();
            userData.append("title", values?.jobtitle);
            userData.append("bio", values?.jobbio);
            userData.append("email", values?.jobemail);
            userData.append("skill", values?.jobskill);
            userData.append("requirement", values?.jobrequirement);
            userData.append("storeName", values?.jobstore);
            userData.append("storeId", values?.jobstore);
            userData.append("salaryRange", values?.jobsalary);
            userData.append("role", values?.jobrole);
            userData.append("type", values?.type);
            userData.append("shiftName", values?.jobshift);
            userData.append("shiftId", values?.jobshift);
            userData.append("educationLevel", values?.jobedulevel);
            userData.append("language", values?.language);
            userData.append("experiene", values?.jobexperience);
            userData.append("mobile", values?.jobmobile);
            userData.append("jobtime", values?.jobtime);
            console.log(userId);
            if (userId) {
            console.log(userId);
              
              dispatch(updateJobs(userId, userData, navigate));
            }
            setSubmitting(false);
          }}
          enableReinitialize={true}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            setFieldValue,
            handleSubmit,
            isSubmitting,
            /* and other goodies */
          }) => {
            return (
              <>
                <div className="container mx-auto mt-4 mb-4 ">
                  <form onSubmit={handleSubmit}>
                    <>
                      {/* <div className="top_bottomEmployee">
                  <h4>Add Employee</h4>
                </div>
                <div className="info_btm">
                  <span>Employee Information</span>
                </div> */}
                      <div className="flex_input">
                        <div className="row_col">
                          <InputField
                            label="Job Title"
                            inputType="text"
                            inputPlaceholder="Enter title"
                            InputFontSize="16px"
                            LabelFontSize="16px"
                            name="jobtitle"
                            value={values.jobtitle}
                            onChange={handleChange}
                            width="23%"
                          />

                          {errors.jobtitle && touched.jobtitle && (
                            <div className="error-message">
                              {errors.jobtitle}
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="flex_input">
                        <div className="row_col">
                          <InputField
                            label="Job Bio"
                            inputType="text"
                            inputPlaceholder="Enter Job Bio"
                            InputFontSize="16px"
                            LabelFontSize="16px"
                            name="jobbio"
                            value={values.jobbio}
                            onChange={handleChange}
                          />

                          {errors.jobbio && touched.jobbio && (
                            <div className="error-message">{errors.jobbio}</div>
                          )}
                        </div>
                        <div className="row_col">
                          <InputField
                            label="Job Role"
                            inputType="text"
                            inputPlaceholder="Enter Job Role"
                            InputFontSize="16px"
                            LabelFontSize="16px"
                            name="jobrole"
                            value={values.jobrole}
                            onChange={handleChange}
                          />

                          {errors.jobrole && touched.jobrole && (
                            <div className="error-message">
                              {errors.jobrole}
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="flex_input">
                        <div className="row_col">
                          <InputField
                            label="Job Requirement and Qualification"
                            inputType="text"
                            inputPlaceholder="Job Requirement and Qualification"
                            InputFontSize="16px"
                            LabelFontSize="16px"
                            name="jobrequirement"
                            value={values.jobrequirement}
                            onChange={handleChange}
                          />

                          {errors.jobrequirement && touched.jobrequirement && (
                            <div className="error-message">
                              {errors.jobrequirement}
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="flex_input">
                        <div className="row_col">
                          <InputField
                            label="Job Skill Set"
                            inputType="text"
                            inputPlaceholder="Job Skill Set"
                            InputFontSize="16px"
                            LabelFontSize="16px"
                            name="jobskill"
                            value={values.jobskill}
                            onChange={handleChange}
                          />

                          {errors.jobskill && touched.jobskill && (
                            <div className="error-message">
                              {errors.jobskill}
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="flex_input">
                        <div className="row_col">
                          <Selector2
                            label="Store"
                            options={storeUsers}
                            name="jobstore "
                            value={values.jobstore}
                            onChange={(selectedOption) => {
                              setFieldValue(
                                "jobstore",
                                selectedOption?.target.value?.value
                              );
                              setFieldValue(
                                "storeId",
                                selectedOption?.target.value?.value
                              );
                            }}
                            LabelFontSize="16px"
                            SelectorFontSize="16"
                          />

                          {errors.jobstore && touched.jobstore && (
                            <div className="error-message">
                              {errors.jobstore}
                            </div>
                          )}
                        </div>
                        <div className="row_col">
                          <InputField
                            label="Salary"
                            inputType="number"
                            inputPlaceholder="Salary"
                            InputFontSize="16px"
                            LabelFontSize="16px"
                            name="jobsalary"
                            value={values.jobsalary}
                            onChange={handleChange}
                          />

                          {errors.jobsalary && touched.jobsalary && (
                            <div className="error-message">
                              {errors.jobsalary}
                            </div>
                          )}
                        </div>
                        <div className="row_col">
                          <Selector2
                            label="Shift"
                            options={shifbytList}
                            name="jobshift"
                            value={values.jobshift}
                            onChange={(selectedOption) => {
                              setFieldValue(
                                "jobshift",
                                selectedOption?.target.value?.value
                              );
                            }}
                            LabelFontSize="16px"
                            SelectorFontSize="16"
                          />
                          {/* <Selector2
                            label="Shift"
                            options={shifbytList}
                            name="jobshift"
                            value={values.jobshift}
                            onChange={(selectedOption) => {
                              setFieldValue("jobshift", selectedOption?.value);

                              const selectedShift = shifbytList.find(
                                (shift) => shift.value === selectedOption?.value
                              );
                              if (selectedShift) {
                                setJobTimingList({
                                  start: selectedShift.start,
                                  end: selectedShift.end,
                                });

                                const estStartTime = moment(selectedShift.start)
                                  .tz("America/New_York")
                                  .format("hh:mm A");
                                const estEndTime = moment(selectedShift.end)
                                  .tz("America/New_York")
                                  .format("hh:mm A");
                                console.log(
                                  `Shift Time in EST: ${estStartTime} - ${estEndTime}`
                                );
                              }
                            }}
                            LabelFontSize="16px"
                            SelectorFontSize="16"
                          /> */}

                          {errors.jobshift && touched.jobshift && (
                            <div className="error-message">
                              {errors.jobshift}
                            </div>
                          )}
                        </div>
                        <div className="row_col">
                          <Selector2
                            label="Time"
                            options={jobTimingList}
                            name="type"
                            value={values.type}
                            onChange={(e) => {
                              setFieldValue("type", e?.target.value?.value);
                            }}
                            LabelFontSize="16px"
                            SelectorFontSize="16"
                          />
                          {/* <Selector2
                            label="Time"
                            options={jobTimingList}
                            name="jobtime"
                            value={jobTimingList.find(
                              (option) => option.value === values.jobtime
                            )}
                            onChange={(option) =>
                              setFieldValue("jobtime", option.value)
                            }
                          /> */}

                          {errors.type && touched.type && (
                            <div className="error-message">
                              {errors.type}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="flex_input">
                        <div className="row_col">
                          <Selector2
                            label="Education Level"
                            options={optionsedu}
                            name="jobedulevel"
                            value={values.jobedulevel}
                            onChange={(e) =>
                              setFieldValue(
                                "jobedulevel",
                                e.target.value?.value
                              )
                            }
                            LabelFontSize="16px"
                            SelectorFontSize="16"
                          />

                          {errors.jobedulevel && touched.jobedulevel && (
                            <div className="error-message">
                              {errors.jobedulevel}
                            </div>
                          )}
                        </div>
                        <div className="row_col">
                          <CustomSelector
                            label="Language"
                            options={optionlanguage}
                            name="language"
                            value={values.language}
                            onChange={(e) =>
                              setFieldValue("language", e.target.value)
                            }
                            LabelFontSize="16px"
                            SelectorFontSize="16"
                            multi={true}
                          />

                          {errors.language && touched.language && (
                            <div className="error-message">
                              {errors.language}
                            </div>
                          )}
                        </div>{" "}
                        <div className="row_col">
                          <Selector2
                            label="Experience"
                            options={optionsjobexperience}
                            name="jobexperience"
                            value={values.jobexperience}
                            onChange={(e) =>
                              setFieldValue(
                                "jobexperience",
                                e.target.value?.value
                              )
                            }
                            LabelFontSize="16px"
                            SelectorFontSize="16"
                          />

                          {errors.jobexperience && touched.jobexperience && (
                            <div className="error-message">
                              {errors.jobexperience}
                            </div>
                          )}
                        </div>
                        <div className="row_col">
                          <InputField
                            label="Mobile"
                            inputType="tel"
                            inputPlaceholder="Enter Mobile"
                            InputFontSize="16px"
                            LabelFontSize="16px"
                            name="jobmobile"
                            value={values.jobmobile}
                            onChange={handleChange}
                            max={10}
                          />

                          {errors.jobmobile && touched.jobmobile && (
                            <div className="error-message">
                              {errors.jobmobile}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="flex_input">
                        <div className="row_col">
                          <InputField
                            label="Email"
                            inputType="text"
                            inputPlaceholder="Enter Email"
                            InputFontSize="16px"
                            LabelFontSize="16px"
                            name="jobemail"
                            value={values.jobemail}
                            onChange={handleChange}
                            width="23%"
                          />

                          {errors.jobemail && touched.jobemail && (
                            <div className="error-message">
                              {errors.jobemail}
                            </div>
                          )}
                        </div>
                      </div>
                    </>

                    <div className="btn_job">
                      <button type="submit" disabled={isSubmitting}>
                        {status == "edit" ? "Add Job" : "Update job"}
                      </button>
                    </div>
                  </form>
                </div>
              </>
            );
          }}
        </Formik>
      </div>
    </div>
  );
};

export default EditJob;
